export default "__VITE_ASSET__b41c2112__"